export default "__VITE_ASSET__BZQt3NFR__"